import { ProjectMapper } from 'src/app/services/remote-data-service/mappers/project.mapper';
import { Mapper } from './mapper';
import { TimeTrack } from 'src/app/entities/time-track/time-track';
import { TimeTrackDto } from 'src/app/services/remote-data-service/dtos/time-track.dto';
import { TagMapper } from './tag.mapper';
import { UserMapper } from './user.mapper';

export class TimeTrackMapper extends Mapper<TimeTrack, TimeTrackDto> {
  /**
   * Project mapper.
   *
   * @protected
   * @memberof ProjectMapper
   */
  protected projectMapper;

  /**
   * Person mapper.
   *
   * @protected
   * @memberof PersonMapper
   */
  protected userMapper;

  /**
   * Tag mapper.
   *
   * @protected
   * @memberof TagMapper
   */
  protected tagMapper;

  constructor() {
    super();
    this.projectMapper = new ProjectMapper();
    this.userMapper = new UserMapper();
    this.tagMapper = new TagMapper();
  }

  mapToEntity(dto: TimeTrackDto): TimeTrack {
    return new TimeTrack(
      dto.uuid,
      dto.title,
      new Date(dto.from),
      dto.to ? new Date(dto.to) : null,
      dto.permissions,
      dto.project ? this.projectMapper.mapToEntity(dto.project) : undefined,
      dto.author ? this.userMapper.mapToEntity(dto.author) : null,
      this.tagMapper.mapToEntities(dto.tags),
      dto.time_spent,
    );
  }
}
